import React, { createContext, useContext, useState } from "react";

interface OrgContextValue {
  selectedOrgId: string | null;
  setSelectedOrgId: (orgId: string | null) => void;
}

const OrgContext = createContext<OrgContextValue | null>(null);

export function OrgProvider({ children }: { children: React.ReactNode }) {
  const [selectedOrgId, setSelectedOrgId] = useState<string | null>(null);

  return (
    <OrgContext.Provider value={{ selectedOrgId, setSelectedOrgId }}>
      {children}
    </OrgContext.Provider>
  );
}

export function useOrgContext() {
  const context = useContext(OrgContext);
  if (!context) {
    throw new Error("useOrgContext must be used within OrgProvider");
  }
  return context;
}
